<div #container aria-labelledby="error-summary-title" class="govuk-error-summary" role="alert" tabindex="-1">
  <h2 class="govuk-error-summary__title" id="error-summary-title">There is a problem</h2>
  <div class="govuk-error-summary__body">
    <ul class="govuk-list govuk-error-summary__list">
      <li>
        <p class="govuk-!-margin-bottom-3">{{ errorSummaryInfo().message }}</p>
        <a [routerLink]="errorSummaryInfo().link">{{ errorSummaryInfo().linkText }}</a>
      </li>
    </ul>
  </div>
</div>
